export const PARAMS = {
    ROUTING_PATHS: {
        ALL_TENDERS_ACTIVE: "/all-tenders/active",
        ALL_TENDERS_ARCHIVE: "/all-tenders/archived",
        // Tenders that already have a result published. Its own route rather than the
        // archive plus a query param, so a results listing is shareable as a URL.
        ALL_TENDERS_RESULTS: "/all-tenders/results",
        // Company pages: /companies (biggest bidders, or ?search=), /companies/<name>-<companyId>.
        COMPETITORS: "/companies",

        //OLD
        TENDER_LIST: "/keywords/",
        PAGE_NOT_FOUND: "/page-not-found",
        ABOUT_US: "/pages/about-us",
        CONTACT_US: "/pages/contact-us",
        HOME: "/",
        LANDING_PAGE: "/pages/download-tender-mobile-app",
        PROFILE: "/profile",
    },

    STATIC_PARAMS: {

        QUERY_TYPE_FILTER: "filter",
        QUERY_TYPE_SORT: "sort",
        QUERY_TYPE_SEARCH: "search",

        SEARCH_TYPE_TENDERS_WITHIN_SAME_ORGANIZATION: "tenders-within-same-organization",
        SEARCH_TYPE_ORGANIZATION: "organization",
        QUERY_KEY: "query",

        // What the search runs against — sent to the auto-suggest API as a query
        // param and to the listing API in the request payload, and carried in the
        // URL so a searched listing stays shareable/bookmarkable.
        SEARCH_FOR: "searchFor",
        SEARCH_FOR_TENDERS: "tenders",
        SEARCH_FOR_RESULTS: "results",
        // Searches companies (bidders) rather than tenders; never sent to the listing API.
        SEARCH_FOR_COMPETITORS: "competitors",

        STATE: "state",
        CITY: "city",
        KEYWORDS: "keywords",
        AUTHORITY: "authority",
        PROCUREMENT: "procurement",
        CATEGORY: "category",
        ORGANIZATION: "organization",
        ORGANISATION: "organisation",
        AMOUNT: "amount",
        START_DATE: "startDate",
        END_DATE: "endDate",
        INCLUDE_EXPIRED: "includeExpired",
        START_DATE_FROM: "startDateFrom",
        END_DATE_FROM: "endDateFrom",

        MOMENT_DIFF_IN_DAYS: "days",
        MOMENT_DIFF_IN_MONTH: "month",
        TOOLTIP_COPIED: "Copied!",
        TENDER_ID: "tenderId",

        HOME: "Home",
        LIST_PAGE: "List Page",
        DETAILS_PAGE: "Details Page",
        GET_IN_TOUCH: "Get in Touch",
        FOOTER: "Footer",
        CONTACT: "Contact",
        DETAILS: "details",
        RIGHT_ARROW: "Right Arrow",
        LEFT_ARROW: "Left Arrow",
        CLICK_ON_CARD: "Click on card",
        VIEW_ALL: "View All",
        SHARE: "Share",
        COPY_LINK: "Copy Link",
        CONTACT_FORM: "Contact Form",
        SUBMITTED: "Submitted",
        CHANGE_LOCATION: "Change Location",
        FILTERS: "Filters",

        GST_DETAILS_PAGE: "gst-details-page",
        GST_LANDING_SEO: "gst-landing-seo",

        // Details Page
        TENDER_DETAILS_PAGE: "tender-details-page",
        TENDER_TWENTY_CITIES_PAGE: "tender-twenty_cities-page",
        TOP_TWENTY_LISTING_CITIES: "top-ten-cities",
        LISTING_PAGE_TENDERS: "tender-listing-page-tenders",
        ALL_LISTING_AUTHORITY: "all-lisitng-authority",
        ALL_LISTING_KEYWORDS: "all-lisitng-keywords",
        WINDOWS_OUTER_WIDTH: 992,
        REQUEST_TYPE_FOOTER_CONTACT_US: 2,
        REQUEST_TYPE_CONTACT_US: 3,
    },

    REGEX: {
        EMAIL_VALIDATOR_REGEX: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        INDIAN_MOBILE_NUMBER_VALIDATOR_REGEX: /^(\+91[\-\s]?)?[0]?(91)?[6789]\d{9}$/,
        IMAGE_DETECT_REGEX: /^http[^\?]*.(jpg|jpeg|gif|png|tiff|bmp)(\?(.*))?$/gmi,
        PREVIEW_DOC_REGEX: /^http[^\?]*.(jpg|jpeg|gif|png|tiff|bmp|pdf)(\?(.*))?$/gmi,
        UNDERSOCRE_REPLACE_WITH_SPACE_REGEX: /_/g,
        DETECT_MOBILE_REGEX: /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i,
    },

    END_DATE_TAGS: [
        { view: "Today", value: 0 },
        { view: "Yesterday", value: 1 },
        { view: "Last 7 Days", value: 7 },
        { view: "Last 30 Days", value: 30 },
    ],

    MIN_AMOUNT_FILTER_LIST: [
        { view: "10K", value: 10000 },
        { view: "20K", value: 20000 },
        { view: "50K", value: 50000 },
        { view: "1Lac", value: 100000 },
        { view: "2Lac", value: 200000 },
        { view: "5Lac", value: 500000 },
        { view: "10Lac", value: 1000000 },
        { view: "50Lac", value: 5000000 },
        { view: "1Cr", value: 10000000 },
        { view: "10Cr", value: 100000000 },
    ],

    MAX_AMOUNT_FILTER_LIST: [
        { view: "50K", value: 50000 },
        { view: "1Lac", value: 100000 },
        { view: "2Lac", value: 200000 },
        { view: "5Lac", value: 500000 },
        { view: "10Lac", value: 1000000 },
        { view: "50Lac", value: 5000000 },
        { view: "1Cr", value: 10000000 },
        { view: "10Cr", value: 100000000 },
        { view: "10Cr+", value: "100000000+" },
    ],

};